/**
 * 敌人数据定义
 */

export interface EnemyDrop {
  itemId: string;
  itemName: string;
  chance: number;   // 0~1
  countMin: number;
  countMax: number;
}

export interface Enemy {
  name: string;
  hp: number;
  attack: number;
  defense: number;
  expReward: number;
  stoneReward: number;
  minRealmIndex: number;
  drops: EnemyDrop[];
}

const D = {
  herb: { itemId: 'spirit_herb', itemName: '灵草', chance: 0.0, countMin: 1, countMax: 1 },
  core: { itemId: 'monster_core', itemName: '妖丹', chance: 0.0, countMin: 1, countMax: 1 },
};

function h(c: number): EnemyDrop { return { ...D.herb, chance: c }; }
function co(c: number): EnemyDrop { return { ...D.core, chance: c }; }

export const ENEMIES: Enemy[] = [
  // ===== 炼气期 =====
  { name: '野狼',  hp: 30,  attack: 5,  defense: 1,  expReward: 20,  stoneReward: 5,   minRealmIndex: 0, drops: [h(0.2)] },
  { name: '山贼',  hp: 50,  attack: 8,  defense: 3,  expReward: 35,  stoneReward: 10,  minRealmIndex: 0, drops: [h(0.15)] },
  { name: '毒蛇',  hp: 25,  attack: 12, defense: 1,  expReward: 30,  stoneReward: 8,   minRealmIndex: 0, drops: [h(0.25)] },
  { name: '石魔',  hp: 80,  attack: 6,  defense: 8,  expReward: 50,  stoneReward: 15,  minRealmIndex: 0, drops: [h(0.3)] },

  // ===== 筑基期 =====
  { name: '妖兽',      hp: 150, attack: 18, defense: 10, expReward: 80,  stoneReward: 30,  minRealmIndex: 1, drops: [h(0.4), co(0.15)] },
  { name: '邪修',      hp: 120, attack: 25, defense: 8,  expReward: 90,  stoneReward: 35,  minRealmIndex: 1, drops: [h(0.2)] },
  { name: '树精',      hp: 200, attack: 15, defense: 15, expReward: 100, stoneReward: 40,  minRealmIndex: 1, drops: [h(0.5), co(0.1)] },
  { name: '灵兽·白虎', hp: 180, attack: 22, defense: 12, expReward: 110, stoneReward: 50,  minRealmIndex: 1, drops: [h(0.3), co(0.25)] },

  // ===== 金丹期 =====
  { name: '魔道修士', hp: 350, attack: 40, defense: 25, expReward: 200, stoneReward: 80,  minRealmIndex: 2, drops: [h(0.3), co(0.3)] },
  { name: '千年蛇妖', hp: 500, attack: 35, defense: 30, expReward: 250, stoneReward: 100, minRealmIndex: 2, drops: [h(0.4), co(0.4)] },
  { name: '鬼王',     hp: 400, attack: 50, defense: 20, expReward: 280, stoneReward: 120, minRealmIndex: 2, drops: [co(0.5)] },
  { name: '蛟龙',     hp: 600, attack: 45, defense: 35, expReward: 350, stoneReward: 150, minRealmIndex: 2, drops: [h(0.5), co(0.5)] },

  // ===== 元婴期 =====
  { name: '天魔族',   hp: 1000, attack: 70, defense: 50, expReward: 600,  stoneReward: 300, minRealmIndex: 3, drops: [co(0.5)] },
  { name: '上古妖兽', hp: 1500, attack: 80, defense: 60, expReward: 750,  stoneReward: 400, minRealmIndex: 3, drops: [h(0.6), co(0.5)] },
  { name: '修罗',     hp: 1200, attack: 95, defense: 45, expReward: 700,  stoneReward: 350, minRealmIndex: 3, drops: [co(0.6)] },

  // ===== 化神期+ =====
  { name: '域外天魔', hp: 2500, attack: 130, defense: 80,  expReward: 1500, stoneReward: 700,  minRealmIndex: 4, drops: [h(0.6), co(0.6)] },
  { name: '九尾天狐', hp: 3000, attack: 120, defense: 100, expReward: 1800, stoneReward: 850,  minRealmIndex: 4, drops: [h(0.7), co(0.6)] },
  { name: '堕仙',     hp: 2800, attack: 150, defense: 90,  expReward: 2000, stoneReward: 1000, minRealmIndex: 4, drops: [co(0.7)] },

  { name: '虚空兽',   hp: 5000,  attack: 220, defense: 150, expReward: 4000, stoneReward: 2000, minRealmIndex: 5, drops: [h(0.7), co(0.7)] },
  { name: '阴阳判官', hp: 4500,  attack: 250, defense: 130, expReward: 4200, stoneReward: 2200, minRealmIndex: 5, drops: [co(0.7)] },

  { name: '混世魔王', hp: 10000, attack: 350, defense: 250, expReward: 8000,  stoneReward: 4500, minRealmIndex: 6, drops: [h(0.8), co(0.7)] },
  { name: '太虚古龙', hp: 12000, attack: 380, defense: 280, expReward: 9500,  stoneReward: 5000, minRealmIndex: 6, drops: [h(0.8), co(0.8)] },

  { name: '天道使者', hp: 25000, attack: 600, defense: 400, expReward: 20000, stoneReward: 10000, minRealmIndex: 7, drops: [co(0.8)] },
  { name: '远古魔神', hp: 30000, attack: 700, defense: 450, expReward: 25000, stoneReward: 13000, minRealmIndex: 7, drops: [h(0.9), co(0.8)] },

  { name: '天劫·雷兽', hp: 60000, attack: 1200, defense: 700, expReward: 50000, stoneReward: 30000, minRealmIndex: 8, drops: [co(0.9)] },
  { name: '飞升劫·心魔', hp: 80000, attack: 1500, defense: 800, expReward: 80000, stoneReward: 50000, minRealmIndex: 8, drops: [h(1.0), co(1.0)] },
];

export function getRandomEnemy(realmIndex: number): Enemy {
  const available = ENEMIES.filter((e) => e.minRealmIndex <= realmIndex);
  if (available.length === 0) return ENEMIES[0];
  const weights = available.map((e) => {
    const diff = realmIndex - e.minRealmIndex;
    return Math.max(1, 10 - diff * 2);
  });
  const totalWeight = weights.reduce((a, b) => a + b, 0);
  let random = Math.random() * totalWeight;
  for (let i = 0; i < available.length; i++) {
    random -= weights[i];
    if (random <= 0) return available[i];
  }
  return available[available.length - 1];
}
